// extracted by mini-css-extract-plugin
export default {"colorLightGreen":"#d9edbf","colorOrange":"#ff9800","colorDarkGreen":"#2c7865","colorGreen":"#90d26d"};